import { useState, type FormEvent } from 'react';
import { submitForm } from '@/lib/formSubmit';

const ENDPOINT = 'https://readdy.ai/api/form/dahc96bp14a1h3mr6ieg';

const topics = ['投稿爆料', '内容纠错', '合作洽谈', '其他问题'];

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const [count, setCount] = useState(0);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus('loading');
    setFormError('');
    const result = await submitForm(form, ENDPOINT);
    if (result.ok) {
      setStatus('success');
      setCount(0);
      form.reset();
      return;
    }
    setStatus('error');
    setFormError(result.message || '提交失败，请稍后再试');
  };

  return (
    <div className="rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-8">
      {status === 'success' ? (
        <div className="flex flex-col items-center py-10 text-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
            <i className="ri-checkbox-circle-line w-7 h-7 flex items-center justify-center text-3xl" />
          </span>
          <h3 className="mt-5 font-heading text-xl text-foreground-950">收到啦，谢谢你的投稿</h3>
          <p className="mt-2 max-w-sm text-sm text-foreground-600">
            我们会在一个工作日内查看，如果被采用，会通过你留下的邮箱联系你。
          </p>
          <button
            type="button"
            onClick={() => setStatus('idle')}
            className="mt-6 whitespace-nowrap rounded-md border border-background-300 px-5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            再写一条
          </button>
        </div>
      ) : (
        <form data-readdy-form id="contact-form" onSubmit={handleSubmit} className="space-y-5">
          <div className="grid gap-5 sm:grid-cols-2">
            <div>
              <label htmlFor="contact-name" className="mb-2 block text-sm font-medium text-foreground-800">
                怎么称呼你
              </label>
              <input
                id="contact-name"
                name="name"
                type="text"
                required
                placeholder="昵称或笔名"
                className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200 placeholder:text-foreground-400"
              />
            </div>
            <div>
              <label htmlFor="contact-email" className="mb-2 block text-sm font-medium text-foreground-800">
                联系邮箱
              </label>
              <input
                id="contact-email"
                name="email"
                type="email"
                required
                placeholder="you@example.com"
                className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200 placeholder:text-foreground-400"
              />
            </div>
          </div>

          <div>
            <label htmlFor="contact-topic" className="mb-2 block text-sm font-medium text-foreground-800">
              想聊点什么
            </label>
            <select
              id="contact-topic"
              name="topic"
              defaultValue={topics[0]}
              className="w-full appearance-none rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            >
              {topics.map((topic) => (
                <option key={topic} value={topic}>
                  {topic}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="contact-message" className="mb-2 block text-sm font-medium text-foreground-800">
              详细说说
            </label>
            <textarea
              id="contact-message"
              name="message"
              required
              maxLength={500}
              rows={5}
              onChange={(event) => setCount(event.target.value.length)}
              placeholder="把你遇到的名场面、想吐槽的瓜，或者发现的问题写在这里（最多 500 字）"
              className="w-full resize-none rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm leading-relaxed text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200 placeholder:text-foreground-400"
            />
            <p className="mt-1.5 text-right text-xs text-foreground-500">{count}/500</p>
          </div>

          <input
            className="form-honeypot"
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
          />

          {status === 'error' && (
            <p className="text-sm text-accent-700">{formError}</p>
          )}

          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto"
          >
            {status === 'loading' ? '提交中…' : '提交内容'}
          </button>
        </form>
      )}
    </div>
  );
}